import { FolderRole } from "@/model/data/deviceTree/FolderRole";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetDataFlowOrganizationsConvertersResData extends ApiGenericResponse {
    converterTypes: string[];
    folderRoles: FolderRole[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        this.converterTypes = [];
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    parse(obj: any) {
        if (obj.ConverterTypes && obj.ConverterTypes.length > 0) {
            obj.ConverterTypes.forEach((e) => {
                this.converterTypes.push(e);
            });
        }

        if (obj.ConvertersFolderRoles) {
            // console.log("obj.ConvertersFolderRoles:", obj.ConvertersFolderRoles);
            this.folderRoles = [];
            this.converterTypes.forEach((converterName: string) => {
                obj.ConvertersFolderRoles[converterName].forEach((element) => {
                    let folderRole = new FolderRole();
                    folderRole.parse(element);
                    folderRole.converterType = converterName;
                    this.folderRoles.push(folderRole);
                });
            });
            // console.log("this.convertersFolderRoles:", this.convertersFolderRoles);
        }
    }
}
